import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AutoComplete } from 'primereact/autocomplete';
import SiteHeader from './../../../components/SiteHeader';

const TaskHeader = props => {

    const userOptions = useSelector((state) => state.common.userList);

    const [filteredUsers, setFilteredUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
  
    const searchUser = (event) => {
        setFilteredUsers(
            userOptions.filter((user) =>
                user?.value?.toLowerCase().includes(event.query.toLowerCase()),
            ),
        );
    };

    const onUserSelect = (e) => {
        setSelectedUser(e.value);
        props.handleSearch(e.value)
        setSelectedUser('')
    };

    const centerContent = (
        <div className="w-full">
            <div className="p-inputgroup">
                <span className="p-inputgroup-addon">
                    <i className="pi pi-search"></i>
                </span>
                <AutoComplete
                    value={selectedUser}
                    suggestions={filteredUsers}
                    completeMethod={searchUser}
                    field="label"
                    onSelect={onUserSelect}
                    placeholder="Search"
                    forceSelection 
                />
            </div>
        </div>
    );

    return (
        <SiteHeader centerContent={centerContent} />
    );
}

export default TaskHeader
